import BaseCard from '../components/Cards/BaseCard';
import { UNIFYADMIN_APP_ID } from '../../constants';
import { IAdoptEaseCampaign } from '../adopt-ease/AdoptEaseCampaignInterface';

interface Props {
  id: string;
  isEnabled: boolean;
  isFavorite?: boolean;
  description: string;
  name: string;
  iconColor: string;
  iconText: string;
  url: string;
  cdkuUrl?: string;
  onClick?: Function;
  onCdkUniversityClick: Function;
  onOpenInNewTabClick: Function;
  onFavoriteChange: Function;
  isRestricted?: boolean;
  restrictedTooltipMsg?: string;
  openInNewTab?: boolean;
  showTryNewAdoptEaseButton?: Function;
  onTryNewAdoptEaseClick: Function;
  showTryNewAdoptEaseCampaign?: (id: string) => IAdoptEaseCampaign | undefined;
  showNewIndicator?: boolean;
  isDefault?: boolean;
  hideStartupOption?: boolean;
  onSetDefaultApp?: (appId: string, appName: string, isDefault: boolean) => void;
  warningMessage?: string;
  requiredOS?: string[];
}

export default function ApplicationCard({
  id,
  isFavorite,
  isEnabled,
  description,
  name,
  iconText,
  iconColor,
  cdkuUrl,
  url,
  onClick,
  onCdkUniversityClick,
  onOpenInNewTabClick,
  onFavoriteChange,
  isRestricted,
  restrictedTooltipMsg,
  openInNewTab,
  showTryNewAdoptEaseButton,
  onTryNewAdoptEaseClick,
  showTryNewAdoptEaseCampaign,
  showNewIndicator,
  isDefault = false,
  hideStartupOption = false,
  onSetDefaultApp,
  warningMessage,
  requiredOS,
}: Props) {
  const showStartup = !hideStartupOption && !!url && url.startsWith('http') && id !== UNIFYADMIN_APP_ID;
  const urlParams = new URLSearchParams(url?.split('?')[1]);
  const isTabLaunch = urlParams.get('launchtype') === 'tab';

  return (
    <>
      <BaseCard
        id={id}
        isIconRequired={true}
        isFavorite={isFavorite}
        learnMoreDescription={description}
        isEnabled={isEnabled}
        name={name}
        iconText={iconText}
        iconColor={iconColor}
        cdkuUrl={cdkuUrl}
        url={url}
        onClick={onClick}
        onCdkUniversityClick={onCdkUniversityClick}
        onOpenInNewTabClick={onOpenInNewTabClick}
        onFavoriteChange={onFavoriteChange}
        isRestricted={isRestricted}
        restrictedTooltipMsg={restrictedTooltipMsg}
        openInNewTab={openInNewTab}
        onTryNewAdoptEaseClick={onTryNewAdoptEaseClick}
        showTryNewAdoptEaseButton={showTryNewAdoptEaseButton}
        showTryNewAdoptEaseCampaign={showTryNewAdoptEaseCampaign}
        showNewIndicator={showNewIndicator}
        showStartupOption={showStartup && !isTabLaunch}
        isDefault={isDefault}
        onSetDefault={onSetDefaultApp}
        warningMessage={warningMessage}
        requiredOS={requiredOS}
      />
    </>
  );
}